require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-receives-national-award-for-adult-financial-education-from.json") })
        }
      }, "path---articles-financial-center-receives-national-award-for-adult-financial-education-from");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-receives-national-award-for-adult-financial-education-from!./.cache/json/articles-financial-center-receives-national-award-for-adult-financial-education-from.json
// module id = 1656
// module chunks = 231608221292675